import { Menu } from "lucide-react";
import ShopFilter from "../ShopFilter";
import DateRangePicker from "../DateRangePicker";

const ReportsHeader = ({ onToggleSidebar }) => (
  <div className="border-b border-gray-200 bg-white sticky top-0 z-20">
    <div className="px-4 py-3 flex flex-wrap items-center gap-3">
      {onToggleSidebar && (
        <button
          type="button"
          onClick={onToggleSidebar}
          className="md:hidden p-1.5 rounded hover:bg-gray-100 text-gray-600"
          aria-label="Mở menu báo cáo"
        >
          <Menu size={18} />
        </button>
      )}
      <h1 className="text-lg font-semibold text-gray-900 mr-4">Báo cáo</h1>
      <ShopFilter />
      <DateRangePicker />
    </div>
  </div>
);

export default ReportsHeader;
